const layers = {
  edit: 'edit',
  detail: 'detail',
};

export default layers;
